import React from 'react';

// Ortak gün seçici (chip tabanlı):
//   "Her gün"      -> job_days = []
//   "Hiçbir zaman" -> job_days = [7]  (kırmızı; çalışmaz)
//   Pzt..Paz       -> 0-6 arası toggle
// value: number[]; onChange: (number[]) => void. Hem onboarding price-check
// hem admin scheduled-jobs ekranında kullanılır.
const DAY_VALUES = [
    {value: 0, key: 'mon'}, {value: 1, key: 'tue'}, {value: 2, key: 'wed'},
    {value: 3, key: 'thu'}, {value: 4, key: 'fri'}, {value: 5, key: 'sat'}, {value: 6, key: 'sun'},
];

const chip = (active, label, onClick, color) => (
    <button type="button" onClick={onClick}
            style={{
                border: active ? `1px solid ${color}` : '1px solid #d1d5db',
                background: active ? color : '#fff',
                color: active ? '#fff' : '#374151',
                borderRadius: 8, padding: '6px 12px', fontSize: '.85rem', fontWeight: 600,
                cursor: 'pointer', transition: 'all .12s',
            }}>
        {label}
    </button>
);

const DaySelector = ({value, onChange, t}) => {
    const jd = value || [];
    const selected = jd.filter(d => d >= 0 && d <= 6);
    const isNever = jd.includes(7);
    const everyDay = !isNever && selected.length === 0;

    const toggleDay = (day) => {
        const cur = jd.filter(d => d >= 0 && d <= 6);
        const has = cur.includes(day);
        onChange(has ? cur.filter(d => d !== day) : [...cur, day].sort((a, b) => a - b));
    };

    return (
        <div style={{display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center'}}>
            {chip(everyDay, t('onboarding.priceCheck.everyDay'), () => onChange([]), '#2563eb')}
            {chip(isNever, t('onboarding.priceCheck.never'), () => onChange([7]), '#dc2626')}
            <span style={{width: 1, alignSelf: 'stretch', background: '#e5e7eb', margin: '0 2px'}}/>
            {DAY_VALUES.map(d => chip(selected.includes(d.value), t('onboarding.priceCheck.day.' + d.key), () => toggleDay(d.value), '#2563eb'))}
        </div>
    );
};

export default DaySelector;
